<template>
  <v-btn
    v-if="showHelpAndServiceButton && !mobileMenuMode"
    icon
    class="d-none d-sm-flex"
  >
    <v-icon 
      :icon="mdiHelpCircle" 
      color="base-white"
    />

    <v-tooltip
      activator="parent"
      location="bottom"
    >
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </v-btn>

  <v-list-item
    v-else-if="showHelpAndServiceButton && mobileMenuMode"
    role="button"
  >
    <template #prepend>
      <v-icon :icon="mdiHelpCircle" />
    </template>
    <v-list-item-title>{{ tooltip }}</v-list-item-title>
  </v-list-item>
</template>


<script>
import { mdiHelpCircle } from '@mdi/js'

export default {
    name: 'CrvAppHelpAndService',

    props: {
      showHelpAndServiceButton: {
        type: Boolean,
        default: true,
      },

      tooltip: {
        type: String,
        default: 'Help & Service',
        // TODO: Implement i18n later
      },

      mobileMenuMode: {
        type: Boolean,
        default: false,
        note: `Shows a list-item instead of a button when in mobile menu mode`,
      },      
    },

    data() {
        return {
          mdiHelpCircle
        }
    },
}
</script>